import { useSelector } from 'react-redux'

const useLoggedInUser = () => useSelector(store => store?.account?.user?.data)

export default useLoggedInUser
